import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { xor } from 'lodash';
import { forwardRef } from 'react';
import { isArrayOfStrings } from 'src/utils';

import { WidgetsCommonProps } from '../widget.interface';
import { Container, HeaderTitle } from './CheckboxGroupWidget.styled';

export const CheckboxGroupWidget = forwardRef(
  (props: WidgetsCommonProps, ref) => {
    return (
      <Container ref={ref}>
        <HeaderTitle>{props.label}</HeaderTitle>
        <FormGroup>
          {props.selectOptions?.map((item, index) => {
            return (
              <FormControlLabel
                key={`${index}-${item.value}}`}
                control={
                  <Checkbox
                    disabled={props.disabled}
                    checked={
                      isArrayOfStrings(props.value)
                        ? props?.value?.includes(item.value)
                        : props.value[index]
                    }
                    onChange={() => {
                      const newDisplayPrice = xor(props.value, [item.value]);

                      props.onChange(newDisplayPrice);
                    }}
                  />
                }
                label={item.label}
              />
            );
          })}
        </FormGroup>
      </Container>
    );
  },
);
